import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { ReceiptSendBackFormContainerProps } from "models/propTypes/receiptPropTypes";
import { ReceiptFormTypes } from "models/formTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import ReceiptSendBackForm from "./receiptSendBackForm";
import { useReceiptService } from "serviceHooks";
//#endregion
import * as Yup from "yup";

const ReceiptSendBackFormContainer: ForwardRefRenderFunction<FormHandles, ReceiptSendBackFormContainerProps> = (
  props,
  ref
) => {
  const receiptService = useReceiptService();
  const validationSchema = Yup.object<ReceiptFormTypes.SendBack>({
    message: Yup.string().required(TranslationKeys.Validations.Required),
  });

  const defaultValues = {
    message: "",
  } as ReceiptFormTypes.SendBack;

  const handleSubmit = (values: ReceiptFormTypes.SendBack) => {
    return receiptService.sendBack(props.receiptId, values.message);
  };

  return (
    <ReceiptSendBackForm
      ref={ref}
      {...props}
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      handleSubmit={handleSubmit}
    />
  );
};

export default forwardRef(ReceiptSendBackFormContainer);
